import React from 'react'
import { Location } from '../svg';

export const TextFieldAdornment = props => {
  const { inputLabel, value, handleChange, inputRef, id , address} = props

  return (
    <div
      id={`${id}_textfield_parent_div`}
      style={{
        display: 'flex',
        justifyontent: 'flex-start',
        alignItems: 'center',
        height: '60px',
        borderRadius: '30px'
      }}
    >
      <div
        id={`${id}_textfield_parent_inputlabel_div`}
        variant='body1'>{inputLabel}</div>
      <input
        className={
          props.active ? "input_placeholder_color" : ""
        }
        style={{
          border: 'none',
          outline: 'none',
          background: props.active ? '#fff' : 'unset',
          fontFamily: 'pc_regular',
          fontSize: 14
        }}
        ref={inputRef}
        {...props}
        // size={'small'}
        label=''
        title={address}
        autoComplete={'no'}
        value={value}
        onChange={handleChange}
        aria-describedby='outlined-weight-helper-text'
        inputProps={{
          'aria-label': 'wesdfsdfight',
          'aria-autocomplete': 'none'
        }}
      // labelWidth={0}
      />
      {props.error && (
        <div
          id={`${id}_textfield_error_sub_div`}
          variant='body1'
          component='div'
        // className={classes.errorText}
        >
          {props.errorText}
        </div>
      )}
      <Location
        id={`${id}_textfield_detectlocation_icon`}
        style={{ cursor: 'pointer' }}
      />
    </div>
  )
}
